import { z } from 'zod';
import { SanityDocumentSchema, SanityReferenceSchema, SanitySlugSchema } from '../sanity';
import { SEOSchema } from '../shared/SEO';
import { EntityType } from '../../types';
import { SanityComponentUnion } from '../components';
import { PageCollectionThemeSchema } from '../shared';
import { CardContentFieldsSchema } from '../shared/CardContent';

export const PageSchema = SanityDocumentSchema.extend({
  _type: z.literal(EntityType.Page),
  name: z.string(),
  slug: SanitySlugSchema,
  theme: PageCollectionThemeSchema.nullish(),
  components: z
    .array(z.union([z.lazy((): z.ZodType => SanityComponentUnion), SanityReferenceSchema]))
    .nullish(),
  cardContent: CardContentFieldsSchema.nullish(),
  format: z.string().nullish(),
  seoAttributes: SEOSchema.nullish()
});

export type Page = z.infer<typeof PageSchema>;
